import { render, staticRenderFns } from "./OpportunityEdit.vue?vue&type=template&id=d15580e0&scoped=true&"
import script from "./OpportunityEdit.vue?vue&type=script&lang=js&"
export * from "./OpportunityEdit.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityEdit.vue?vue&type=style&index=0&id=d15580e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15580e0",
  null
  
)

export default component.exports